module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"gatsby-starter-default","short_name":"starter","start_url":"/","background_color":"#009912","theme_color":"#999400","display":"minimal-ui","icon":"src/assets/favicon/logo.svg","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"7a7d79282106e5c519617943a95b2b77"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
